import type { Dictionary } from 'shared/legacy/contexts/LocalizationContext/types';

import { isAxiosError } from 'helpers/clientHelpers';
import { BadRequestException } from './BadRequestException';
import { getIndeedCandidateEngagementErrorMessage } from './getIndeedCandidateEngagementErrorMessage';

export function resolveIndeedRjSendErrorMessage(error: unknown, dictionary: Dictionary): string {
  const engagementMessage = getIndeedCandidateEngagementErrorMessage(error, dictionary);
  if (engagementMessage) return engagementMessage;

  if (error instanceof BadRequestException) return dictionary.pleaseTryAgainOrContactUs;

  if (isAxiosError(error) && error.response?.status === 400) {
    return dictionary.pleaseTryAgainOrContactUs;
  }

  return dictionary.somethingWentWrong;
}
